import memoizeOne from 'memoize-one';
import { token } from '@atlaskit/tokens';
import messages from './messages';

export const formattingColors: {
	[key: string]: {
		label: { id: string; defaultMessage: string; description: string };
		value: string;
	};
} = {
	lightPurple: {
		label: messages.lightPurple,
		value: token('color.background.accent.purple.subtlest', '#f3f0ff'),
	},
	lightBlue: {
		label: messages.lightBlue,
		value: token('color.background.accent.blue.subtlest', '#e9f2ff'),
	},
	lightGreen: {
		label: messages.lightGreen,
		value: token('color.background.accent.green.subtlest', '#DCFFF1'),
	},
	lightTeal: {
		label: messages.lightTeal,
		value: token('color.background.accent.teal.subtlest', '#E7F9FF'),
	},
	lightYellow: {
		label: messages.lightYellow,
		value: token('color.background.accent.yellow.subtlest', '##FFF7D6'),
	},
	lightRed: {
		label: messages.lightRed,
		value: token('color.background.accent.red.subtlest', '##FFF7D6'),
	},
	lightGray: {
		label: messages.lightGray,
		value: token('color.background.accent.gray.subtlest', '##FFF7D6'),
	},
	purple: {
		label: messages.purple,
		value: token('color.background.accent.purple.subtler', '#f3f0ff'),
	},
	blue: {
		label: messages.blue,
		value: token('color.background.accent.blue.subtler', '#DFD8FD'),
	},
	green: {
		label: messages.green,
		value: token('color.background.accent.green.subtler', '#C6EDFB'),
	},
	teal: {
		label: messages.teal,
		value: token('color.background.accent.teal.subtler', '#F8E6A0'),
	},
	yellow: {
		label: messages.yellow,
		value: token('color.background.accent.yellow.subtler', '#FFF7D6'),
	},
	red: {
		label: messages.red,
		value: token('color.background.accent.red.subtler', '#FFD5D2'),
	},
	gray: {
		label: messages.gray,
		value: token('color.background.accent.gray.subtler', '#DCDFE4'),
	},
};

export const getColorKeyFromValue = memoizeOne((value: string) => {
	const selectedColor = Object.entries(formattingColors).find(
		([_, color]) => color.value === value,
	);

	return selectedColor?.[0];
});
